import { connect } from 'react-redux';
import { validateFilters } from '@cian/valuation-main-filters-widget';

import { IApplicationState } from '../../types/redux';
import {
  ValuationFiltersSubmit,
  IValuationFiltersSubmitDispatchProps,
  IValuationFiltersSubmitStoreProps,
} from '../../components/ValuationFiltersSubmit';
import { submitValuationForm } from '../../actions/submitValuationForm';
import { getButtonText } from './utils';

export const mapStateToProps = (state: IApplicationState): IValuationFiltersSubmitStoreProps => {
  const {
    filters: { estimationTarget },
    page: { deviceType },
  } = state;

  const isMobile = deviceType === 'phone';

  return {
    buttonText: getButtonText(isMobile, estimationTarget),
    estimationTarget,
  };
};

export const mapDispatchToProps: IValuationFiltersSubmitDispatchProps = {
  handleValidate: validateFilters as any, // eslint-disable-line
  handleSubmit: submitValuationForm,
};

export const ValuationFiltersSubmitContainer = connect<
  IValuationFiltersSubmitStoreProps,
  IValuationFiltersSubmitDispatchProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(ValuationFiltersSubmit);
